import { Component, inject, Input } from '@angular/core'
import Guest, {
	STATUS_CONFIRMED,
	STATUS_PENDING,
	STATUS_DECLINED,
} from '@client/Guest'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'

import { GuestService } from '@client/Services/GuestService'
import HttpError from '@ui/HttpError'

@Component({
	selector: 'guest-actions',
	templateUrl: './GuestActions.Component.html',
	imports: [RaisedButtonComponent],
})
export class GuestActionsComponent {
	@Input() protected guest: Guest

	@Input() protected guestUpdated: (guest: Guest) => void

	protected status: string = 'Unconfirmed'

	protected readonly STATUS_PENDING = STATUS_PENDING

	protected readonly STATUS_CONFIRMED = STATUS_CONFIRMED

	protected readonly STATUS_DECLINED = STATUS_DECLINED

	private readonly guestService: GuestService

	constructor() {
		this.guestService = inject(GuestService)
	}

	public accept = async (): Promise<void> => {
		this.guest.status = STATUS_CONFIRMED

		await this.updateGuest(this.guest)
	}

	public decline = async (): Promise<void> => {
		this.guest.status = STATUS_DECLINED

		await this.updateGuest(this.guest)
	}

	private readonly updateGuest = async (guest: Guest): Promise<void> => {
		try {
			const result = await this.guestService.updateGuest(guest)

			this.guestUpdated(result)
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
